export const BENEFIT_HOME_TAB = {
  EARN: 'earn',
  USE: 'use',
} as const;

export type BenefitHomeTab =
  (typeof BENEFIT_HOME_TAB)[keyof typeof BENEFIT_HOME_TAB];

export const BENEFIT_HOME_TABS_ID = 'benefit-home-tabs';

//* 서버 프리페치와 클라이언트 쿼리 키가 같아야 하이드레이션된다.
export const SPECIALTY_PRODUCT_QUERY = { query: { size: 4 } };

//* 서버 혜택 메뉴의 placementKey가 이 값이면 오퍼월이 아니라 행운권 광고보기 칸이다(어드민 메뉴에 이 값을 입력).
export const LUCKY_TICKET_AD = 'LUCKY_TICKET_AD';

//* 혜택홈 모으기 탭에서 「행운의 로또」 카드를 맨 위에 넣을 서버 메뉴 그룹 제목.
export const LUCKY_LOTTO_GROUP_TITLE = '행운권 · 웰포인트 즉시 받기';
